module.exports = __webpack_public_path__ + "static/media/tom-ford.d9154017.jpg";